import React, { Component } from 'react';
import './SplitterRL.scss';

class SplitterRL extends Component {
    dragElement = (element, direction) => {
        var md; // remember mouse down info
        const first = document.getElementById("first");
        const second = document.getElementById("second");

        let onMouseMove = (e) => {
            //console.log("mouse move: " + e.clientX);
            var delta = {
                x: e.clientX - md.e.clientX,
                y: e.clientY - md.e.clientY
            };

            if (direction === "H") // Horizontal
            {
                // Prevent negative-sized elements
                delta.x = Math.min(Math.max(delta.x, -md.firstWidth),
                    md.secondWidth);

                element.style.left = md.offsetLeft + delta.x + "px";
                first.style.width = (md.firstWidth + delta.x) + "px";
                second.style.width = (md.secondWidth - delta.x) + "px";
            }
        }

        let onMouseDown = (e) => {
            //console.log("mouse down: " + e.clientX);
            md = {
                e,
                offsetLeft: element.offsetLeft,
                offsetTop: element.offsetTop,
                firstWidth: first.offsetWidth,
                secondWidth: second.offsetWidth
            };

            document.onmousemove = onMouseMove;
            document.onmouseup = () => {
                this.props.onSplitted?.(first.style.width, second.style.width);
                document.onmousemove = document.onmouseup = null;
            }
        }

        element.onmousedown = onMouseDown;
    }

    componentDidMount() {
        this.dragElement(document.getElementById("separator"), "H");
    }

    render() {
        return (
            <div class="splitter">
                <div id="first">{this.props.leftPan}</div>
                <div id="separator" >&nbsp;</div>
                <div id="second" >{this.props.rightPan}</div>
            </div>
        );
    }
}


export default SplitterRL;